var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6407 21.3744H5.35938C4.3686 21.3744 3.5625 20.5683 3.5625 19.5775V10.1236C3.5625 9.77841 3.84231 9.49857 4.1875 9.49857C4.5327 9.49857 4.8125 9.77841 4.8125 10.1236V19.5775C4.8125 19.8791 5.05782 20.1244 5.35938 20.1244H18.6407C18.9422 20.1244 19.1875 19.8791 19.1875 19.5775V10.1236C19.1875 9.77841 19.4673 9.49857 19.8125 9.49857C20.1577 9.49857 20.4375 9.77841 20.4375 10.1236V19.5775C20.4375 20.5683 19.6315 21.3744 18.6407 21.3744Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 12.3109C21.2151 12.3109 21.0552 12.2499 20.9331 12.1278L13.1601 4.35489C12.5204 3.7152 11.4796 3.7152 10.8399 4.35489L3.06695 12.1279C2.82288 12.372 2.42714 12.372 2.18308 12.1279C1.93897 11.8838 1.93897 11.4881 2.18308 11.244L9.95606 3.47098C11.0831 2.34394 12.917 2.34394 14.044 3.47098L21.8169 11.244C22.0611 11.4881 22.0611 11.8838 21.8169 12.1278C21.695 12.2499 21.535 12.3109 21.375 12.3109Z",
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.3744H9.5C9.15481 21.3744 8.875 21.0946 8.875 20.7494V15.2025C8.875 14.1256 9.75117 13.2494 10.8281 13.2494H13.1719C14.2488 13.2494 15.125 14.1256 15.125 15.2025V20.7494C15.125 21.0946 14.8452 21.3744 14.5 21.3744ZM10.125 20.1244H13.875V15.2025C13.875 14.8148 13.5596 14.4994 13.1719 14.4994H10.8281C10.4404 14.4994 10.125 14.8148 10.125 15.2025V20.1244Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.ef3da478ecdb57815119b6e4ca01818f.svg";
export { ForwardRef as ReactComponent };